// TODO add api connection
import { PageService } from "@/api";

// state
const state = () => ({
	isLoaded: false,
	pages: [],
	currentPageSlug: null,
});

// getters
const getters = {
	currentPage: (state) => {
		return state.currentPageSlug in state.pages ? state.pages[state.currentPageSlug] : false;
	},
};

// actions
const actions = {
	async getPage({ state, commit }, payload) {
		const { lang, path } = payload;
		const pathArr = path.split("/");
		if (path.charAt(0) === "/") {
			pathArr.splice(0, 1);
		}

		if (path.charAt(path.length - 1) === "/") {
			pathArr.splice(pathArr.length - 1, 1);
		}

		// FIXME add support for advices;
		const slug = pathArr[pathArr.length - 1];
		const key = `${lang}_${slug}`;
		let postType = "page";

		if (pathArr.length > 2) {
			postType = pathArr[pathArr.length - 2];
		}

		if (slug === "news") {
			const pageData = {
				langs: {
					de: process.env.VUE_APP_HTTP + "/news",
					en: process.env.VUE_APP_HTTP + "/en/news",
					fr: process.env.VUE_APP_HTTP + "/fr/news",
					it: process.env.VUE_APP_HTTP + "/it/news",
				},
			};
			commit("pushPage", { page: pageData, key: key });
			commit("setCurrentPageSlug", key);
		}

		if (!slug) {
			commit("setCurrentPageSlug", null);
			return true;
		}

		if (key in state.pages) {
			commit("setCurrentPageSlug", key);
			return true;
		}

		const resp = await PageService.getPageBySlug(lang, slug, postType);
		const page = resp;

		commit("pushPage", { page: page, key: key });
		commit("setCurrentPageSlug", key);

		return resp;
	},
};

// mutations
const mutations = {
	pushPage(state, payload) {
		state.pages[payload.key] = payload.page;
	},
	setCurrentPageSlug(state, key) {
		state.currentPageSlug = key;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
